module.exports = __webpack_public_path__ + "static/img/IDaaS-banner.163304ad.png";